import React from 'react'
import { EditableText } from '@smartfire/components'
import { defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine'
import { useSmartField } from '@smartfire/wordpress-smartforms'
import style from './block.module.scss'

const Inspector = React.lazy(() => import('./Inspector.js'))

const Block = ({ fieldType, placeholder, ...props }) => {
    useInspectorControl(Inspector)

    const { field } = useSmartField({
        smartProp: 'input',
        type: fieldType,
        default: {
            name: 'input',
        },
    })

    return (
        <div className={style.blockInput}>
            <div className={style.contentLabel}>
                <EditableText
                    smartProp="label"
                    tagName="label"
                    tagProps={{
                        htmlFor: field?.blockId,
                    }}
                    className={style.label}
                    placeholder={'Insérer un label...'}
                />
                {field?.required && <span className={style.required}>*</span>}
            </div>
            <input
                type={fieldType}
                name={field?.name}
                id={field?.blockId}
                required={field?.required}
                placeholder={placeholder}
                {...props}
            />
        </div>
    )
}

export default defineBlock({
    Block,
    setup: {
        title: 'Input',
        parent: [
            'smartfire/contact---form---form-content',
            'smartfire/contact---form---form-content---two-columns',
        ],
    },
    smartProps: {
        input: smartProps.object,
        label: smartProps.string.withDefault(''),
        fieldType: smartProps.string.withDefault('text'),
        placeholder: smartProps.string.withDefault('Placeholder'),
    },
})
